import {
    FETCH_USER_ATTN_BY_USERID,
    FETCH_USER_ADDRESS_BY_USERID,
    FETCH_USER_REAL_NAME_BY_USERID,
    FETCH_USER_COMMON_ATTN_BY_USERID,
} from '../mutation-types'

const initialState = {
  attn: [],
  address: [],
  realName: [],
  commonAttn: {},
}

const mutations = {
  [FETCH_USER_ATTN_BY_USERID](state, data) {
    state.attn = data.attns
  },
  [FETCH_USER_ADDRESS_BY_USERID](state, data) {
    state.address = data.addresses
  },
  [FETCH_USER_REAL_NAME_BY_USERID](state, data) {
    state.realName = data.realNameInfos
  },
  [FETCH_USER_COMMON_ATTN_BY_USERID](state, data) {
    state.commonAttn = data
  },
}

export default {
  state: initialState,
  mutations,
}



// WEBPACK FOOTER //
// ./client/vuex/modules/attn.js